import React from "react";
import "./index.scss";

const Stars = () => {
  const arr = new Array(20).fill(0);
  return (
    <div className="start-group">
      <div className="stars">
        {arr.map((item, index) => (
          <div key={index} className="star"></div>
        ))}
      </div>
      <div className="stars2">
        {arr.map((item, index) => (
          <div key={index} className="star2"></div>
        ))}
      </div>
    </div>
  );
};

export default Stars;
